<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/maintenance_histories/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import AssetableTable from "@/pages/components/assets/AssetableTable.vue";

export default {
	mixins: [UpdateForm],
	components: {AssetableTable, App, Form},
	props: ['maintenance_history_id', 'product', 'assetableTableConfig'],
	data() {
		return {
			formRoute: route('api.v1.products.maintenance_histories.update', {'product': this.product.id, 'maintenance_history': this.maintenance_history_id}),
			redirectRoute: route('products.maintenance_histories.index', {'product': this.product.id}),
		}
	},
	methods: {
		afterSuccess(form, response) {
			this.getMaintenanceHistory();
		},

		getMaintenanceHistory() {
			this.loading = true;
			$.ajax({
				url: route('api.v1.products.maintenance_histories.show', {'product': this.product.id, 'maintenance_history': this.maintenance_history_id}),
				success: (response) => {
					this.$refs.form.setMaintenanceHistory(response.data);
				}
			}).always(() => {
				this.loading = false;
			})
		}
	},
	mounted() {
		this.getMaintenanceHistory();
	}
}
</script>

<template>
	<App title="Onderhoudshistorie bewerken">
		<form id="maintenanceHistoryForm" @submit.prevent="submit">
			<Form ref="form">

				<template #maintenanceWidget>

							<AssetableTable
								v-if="assetableTableConfig"
								:table-config="assetableTableConfig"
								:assetable-id="this.maintenance_history_id"
								assetable-type="maintenance_history"
								assetable-group="images"
								title="Afbeeldingen"
								id="maintenanceimages"
							></AssetableTable>
				</template>
			</Form>
		</form>

		<template #bottomButtons>
			<FormButtons
				@backToOverview="stayOnPage = 0"
				:loading="loading"
				form-id="maintenanceHistoryForm"
				:cancel-route="redirectRoute"
			/>
		</template>
	</App>
</template>